const StepDescription = ({ formData, handleInputChange }) => {
  return (
    <div className="space-y-6">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Description *
        </label>
        <textarea
          rows={6}
          required
          className="w-full px-4 py-3 border border-gray-200 rounded-lg text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent transition-all duration-200 bg-white/50 resize-none"
          placeholder="Describe your listing experience, what guests can expect, activities included, and what makes it special..."
          value={formData.description}
          onChange={(e) => handleInputChange('description', e.target.value)}
        />
        <p className="mt-1 text-xs text-gray-500">
          {formData.description.length.toLocaleString()} characters
        </p>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Highlights *
        </label>
        <textarea
          rows={4}
          required
          className="w-full px-4 py-3 border border-gray-200 rounded-lg text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent transition-all duration-200 bg-white/50 resize-none"
          placeholder="Key highlights and unique features of your listing (one per line)"
          value={formData.highlights}
          onChange={(e) => handleInputChange('highlights', e.target.value)}
        />
        <p className="mt-1 text-xs text-gray-500">
          {formData.highlights.length.toLocaleString()} characters
        </p>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          What's Included
        </label>
        <textarea
          rows={3}
          className="w-full px-4 py-3 border border-gray-200 rounded-lg text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent transition-all duration-200 bg-white/50 resize-none"
          placeholder="What's included in the listing (meals, equipment, etc.)"
          value={formData.whatIncluded}
          onChange={(e) => handleInputChange('whatIncluded', e.target.value)}
        />
        <p className="mt-1 text-xs text-gray-500">
          {formData.whatIncluded.length.toLocaleString()} characters
        </p>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          What to Bring
        </label>
        <textarea
          rows={3}
          className="w-full px-4 py-3 border border-gray-200 rounded-lg text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent transition-all duration-200 bg-white/50 resize-none"
          placeholder="What guests should bring"
          value={formData.whatToBring}
          onChange={(e) => handleInputChange('whatToBring', e.target.value)}
        />
        <p className="mt-1 text-xs text-gray-500">
          {formData.whatToBring.length.toLocaleString()} characters
        </p>
      </div>
    </div>
  );
};

export default StepDescription;

